<div [style.width.px]="size" [style.height.px]="size" class="square-percentage-container">
  <div *ngFor="let i of nums;" class="square-percentage-item"
       [ngClass]="i < percentage ? 'percentage-color': ''">
  </div>
</div>
